import { Evento } from './eventos/evento';
import { Injectable } from '@angular/core';

@Injectable()
export class ComumService {

  public evento: Evento;

  constructor() {
    this.evento = new Evento();
  }

  cleanEvent(): void {
    this.evento.limparEventos();
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/comum.service.ts